import React from "react";

// Editorial section header: numbered index chip + title on the left, lede on the right.
export const IndexNo = ({ no, label, dark = false }) => (
  <span className="inline-flex items-center gap-2.5 mb-4">
    <span
      className={`font-display text-[12.5px] font-bold border px-2 py-[3px] leading-[1.4] ${
        dark ? "text-white border-white/50" : "text-[#04162E] border-[#04162E]"
      }`}
    >
      {no}
    </span>
    <span className={`font-body text-[13px] font-semibold ${dark ? "text-[#0E8A57]" : "text-[#0B6B44]"}`}>
      {label}
    </span>
  </span>
);

export const SectionHead = ({ no, label, title, sub, dark = false }) => (
  <div className="grid md:grid-cols-2 gap-6 md:gap-10 items-end mb-[52px]">
    <div>
      <IndexNo no={no} label={label} dark={dark} />
      <h2
        className={`font-display font-bold text-[26px] sm:text-[32px] lg:text-[38px] leading-[1.15] max-w-[14ch] ${
          dark ? "text-white" : "text-[#04162E]"
        }`}
      >
        {title}
      </h2>
    </div>
    <p className={`font-body text-base leading-[1.65] max-w-[44ch] ${dark ? "text-[#8FA0B3]" : "text-[#5C6C80]"}`}>
      {sub}
    </p>
  </div>
);
